import React, { useState, useEffect } from 'react'
import formatNumber from '../../../utils/formatNumber'

import './popup-login.scss'

const PopupLogin = props => {

    const [popupState, setPopupState] = useState(false)

    useEffect(() => {

        setTimeout(() => {//Set animation inside
            setPopupState(true)
        }, 600);

        setTimeout(() => {//Set animation outside
            setPopupState(false)
        }, 5000);
    }, [])

    return (
        <div className={"f-popup-box " + (popupState && "active-popup")}>
            <div className="f-popup-container">
                <div className="f-user-info-container">

                    <div className="f-avatar-img-container">
                        <img
                            className="f-avatar-img"
                            src={props.infoUser.profilePicture}
                            alt="Avatar imagen"
                        />
                    </div>

                    <div className="f-text-container">
                        <label className="f-name-user">{'¡Hola, ' + props.infoUser.name.split(" ")[0] + '!'}</label>
                        {props.havePoints && <label className="f-points-user">{formatNumber(props.infoUser.userPoints.pointsAccumulation + props.infoUser.userPoints.pointsPresent)} PUNTOS</label>}
                        <label className="f-action-text"> Haz iniciado sesión</label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PopupLogin
